import * as WarrantyErrorCodes from './warrantyErrorCodes';
import * as WarrantyTasksCodes from './warrantyTasksCodes';

const Actions = {
  ...WarrantyErrorCodes,
  ...WarrantyTasksCodes,
};

export default Actions;
